import React from 'react';
import { AnimatedStatCard, ResourceStatCard } from './StatCards';
import styles from './OverviewSection.module.css';

type SectionKey =
  | 'overview'
  | 'users'
  | 'documents'
  | 'transcripts'
  | 'admins'
  | 'jurisdictions'
  | 'settings'
  | 'profile'
  | 'account';

export interface OverviewMetric {
  label: string;
  value: number;
  badge: string;
  actionSection?: SectionKey;
}

export interface ResourceCard {
  label: string;
  value: number;
  description: string;
  accentClass: string;
  icon?: JSX.Element;
}

export interface OverviewSectionProps {
  metrics: OverviewMetric[];
  resourceCards: ResourceCard[];
  onMetricClick?: (section: SectionKey) => void;
}

export const OverviewSection: React.FC<OverviewSectionProps> = ({ 
  metrics, 
  resourceCards,
  onMetricClick 
}) => {
  const heroRowOne = metrics.slice(0, 2);

  return (
    <section className={`${styles.section} ${styles.sectionMinimal}`}>
      <div className={styles.heroBanner}>
        <div className={styles.heroRow}>
          {heroRowOne.map(metric => (
            <AnimatedStatCard
              key={metric.label}
              label={metric.label}
              value={metric.value}
              badgeClass={metric.badge}
              onClick={metric.actionSection ? () => onMetricClick?.(metric.actionSection!) : undefined}
            />
          ))}
        </div>
        <div className={styles.resourceGrid}>
          {resourceCards.map(card => (
            <ResourceStatCard
              key={card.label}
              label={card.label}
              value={card.value}
              description={card.description}
              accentClass={card.accentClass}
              icon={card.icon}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
